import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'

export const Button = styled.button`
  font-family: ${props=>props.theme.fonts.h2};
  font-weight: bold;
  font-size: 14px;
  line-height: 1.5em;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  text-align:center;
  display: block;
  margin-top: 12px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 25px;
  color: black;
  border: 4px solid black;
  -webkit-appearance: none;
  border-radius: 3px;
  cursor: pointer;

  &:focus {
    background-color: black;
    color: white;
    text-decoration: underline;
    outline: none;
  }

  @media not all and (hover: none) {
    &:hover{
      background-color: black;
      color: white;
    }
  }

`;

class LogoutButton extends React.Component {
  handleLogout = (event) => {
    const { store } = this.context;
    store.dispatch({
      type: "LOGOUT_REQUESTED"
    });
  }
  render() {
    return (
      <Button onClick={this.handleLogout}>
        Logout
      </Button>
    );
  }
}

LogoutButton.contextTypes = {
  store: PropTypes.object
};

export default LogoutButton;



// WEBPACK FOOTER //
// ./src/components/buttons/logout-button.js